import convertDates from "./converters/convert-dates";
import convertPercents from "./converters/convert-percents";
import convertUnits from "./converters/convert-units";

function convertAll(obj, prefered) {
  /* `in` checks in converters require a real object; `api()` may pass JSON strings (e.g. POST body). */
  if (obj == null || typeof obj !== "object") return obj;
  convertPercents.call(this, obj, prefered);
  convertDates.call(this, obj, prefered);
  convertUnits.call(this, obj, prefered);
  return obj;
}

export default convertAll;
